import { ATSTabbedJobViewAutomationsTabTestIds } from 'data-testids/ATS';
import { AutomationList } from 'features/Automations/AutomationList/AutomationList';
import { AutomationModalPaneOptions } from 'features/Automations/enums';
import { HasAutomationsProps } from '../types';
import { SecondaryButton } from '../styles';
import { useAutomation } from 'features/Automations/context/AutomationContext';
import { useQueryGetAutomationsListData } from 'features/Automations/api/listQueries';

export const HasAutomations = ({ onOpenModal }: HasAutomationsProps) => {
  const { onChangeModalPane } = useAutomation();
  const { roleId } = useAutomation();
  const { data } = useQueryGetAutomationsListData(roleId);

  return (
    <>
      <AutomationList
        variant="read_only"
        automationState={{ automations: data, hasUnsavedChanges: false }}
        automationDispatch={() => {}}
      />
      <SecondaryButton
        data-testid={ATSTabbedJobViewAutomationsTabTestIds.EDIT_AUTOMATION_BUTTON}
        variant="outlined"
        sx={{ borderRadius: 2, width: '30%' }}
        onClick={() => {
          onOpenModal();
          onChangeModalPane(AutomationModalPaneOptions.LIST);
        }}
      >
        Edit
      </SecondaryButton>
    </>
  );
};
